import admin from '@/apps/admin/lang/de'
import brelag from '@/apps/brelag/common/lang/de'
import wesco from '@/apps/brelag/mandator-user/custom-mandators/wesco/lang/de/index'
import components from '@/lang/lang-de/components'
import knockaut from '@/lang/lang-de/knockaut'
import models from '@/lang/lang-de/models'

const apps = {
  admin,
  brelag,
}

export default {
  components,
  models,
  apps,
  wesco,
  knockaut,
}
